import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { QuestionType } from 'store/modules/Quesionnare/types';
import { Responses } from './QuestionaireForm';
import { useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles({
  indicator: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'center',
    justifyContent: 'center',
    marginTop: '12px',
    flexWrap: 'wrap'
  }
});
interface IndicatorProps {
  selectedIndex: number;
  surveyData: QuestionType[];
  indicatorNavigation: Function;
  responses: Responses[];
}

const Indicator = ({
  selectedIndex,
  surveyData,
  indicatorNavigation,
  responses
}: IndicatorProps) => {
  const theme = useTheme() as any;
  const classes = useStyles();
  return (
    <React.Fragment>
      {selectedIndex <= surveyData.length - 1 && (
        <div className={classes.indicator}>
          {surveyData.map((question, i) => {
            return (
              <Typography
                onClick={() => {
                  if (i <= responses.length - 1) {
                    indicatorNavigation(i);
                  }
                }}
                key={`q_${i + 1}`}
                component="p"
                style={{
                  margin: '4px',
                  color: selectedIndex > i ? 'white' : 'lightgray',
                  backgroundColor:
                    selectedIndex > i - 1
                      ? theme.palette.secondary.main
                      : 'white',
                  width: '24px',
                  height: '24px',
                  borderRadius: '50%',
                  cursor: 'pointer'
                }}
              >
                {i + 1}
              </Typography>
            );
          })}
        </div>
      )}
    </React.Fragment>
  );
};

export default Indicator;
